import { useState, useEffect, useContext } from 'react';
import { connectGoogleCalendar } from '../utils/googleSync';
import {
  format,
  startOfMonth,
  endOfMonth,
  startOfWeek,
  endOfWeek,
  add,
  isToday,
  isSameMonth,
  startOfDay,
} from 'date-fns';
import {
  ChevronLeftIcon,
  ChevronRightIcon,
  MapPinIcon,
  UserCircleIcon,
  ClockIcon,
} from '@heroicons/react/20/solid';
import { useNavigate } from 'react-router-dom';
import LoadingComponent from './loading';
import { AuthContext } from '../AuthContext';
import Navbar from './managernav';

const navigation = [
  { name: 'Onboarding', href: '#onboarding', icon: null, current: true, group: 'onboarding' },
  { name: 'Company Info', href: '#company-info', icon: null, current: false, group: 'onboarding' },
  { name: 'Role Calibration', href: '#role-calibration', icon: null, current: false, group: 'onboarding' },
  { name: 'Policies', href: '#policies', icon: null, current: false, group: 'onboarding' },
  { name: 'User Management', href: '#user-management', icon: null, current: false, group: 'onboarding' },
  { name: 'Create Teams', href: '#members', icon: null, current: false, group: 'onboarding' },
  { name: 'Staff Costs', href: '#staff-costs', icon: null, current: false, group: 'onboarding' },
  { name: 'Process Creator', href: '#process-creator', icon: null, current: false, group: 'onboarding' },
  { name: 'Admin Dashboard', href: '#admin-dashboard', icon: null, current: false, group: 'ui' },
  { name: 'Activity Feed', href: '#activity-feed', icon: null, current: false, group: 'ui' },
  { name: 'Stats', href: '#stats', icon: null, current: false, group: 'ui' },
  { name: 'Records', href: '#staff-details', icon: null, current: false, group: 'management' },
  { name: 'Reporting', href: '#reporting', icon: null, current: false, group: 'management' },
  { name: 'Appraisal Forms', href: '#appraisal-forms', icon: null, current: false, group: 'management' },
  { name: 'Edit Appraisal', href: '#edit-appraisal', icon: null, current: false, group: 'management' },
  { name: 'Disciplinary Form', href: '#disciplinary-form', icon: null, current: false, group: 'management' },
  { name: 'HR', href: '#hr', icon: null, current: false, group: 'management' },
  { name: 'Back-to-Work Dashboard', href: '#back-to-work-dashboard', icon: null, current: false, group: 'management' },
  { name: 'Back-to-Work Form', href: '#back-to-work-form', icon: null, current: false, group: 'management' },
  { name: 'Sickness AI', href: '#sickness-ai', icon: null, current: false, group: 'management' },
  { name: 'Sickness Report', href: '#sickness-report', icon: null, current: false, group: 'management' },
  { name: 'Analytics', href: '#analytics', icon: null, current: false, group: 'management' },
  { name: 'Overtime Manager', href: '#overtime-manager', icon: null, current: false, group: 'management' },
  { name: 'Travel', href: '#travel', icon: null, current: false, group: 'management' },
  { name: 'Clock In', href: '#clock-in', icon: null, current: false, group: 'management' },
  { name: 'Book Shifts', href: '#book-shifts', icon: null, current: false, group: 'management' },
  { name: 'Holiday Chart', href: '#holiday-chart', icon: null, current: false, group: 'management' },
  { name: 'Holiday Booking', href: '#holiday-booking', icon: null, current: false, group: 'management' },
  { name: 'Meetings', href: '#meetings', icon: null, current: false, group: 'management' },
  { name: 'Admin Tasks', href: '#admin-tasks', icon: null, current: false, group: 'management' },
  { name: 'Chat', href: '#communications', icon: null, current: false, group: 'general' },
  { name: 'My Profile', href: '#my-profile', icon: null, current: false, group: 'general' },
  { name: 'Visitor Management', href: '#visitor-management', icon: null, current: false, group: 'general' },
  { name: 'User Sessions', href: '#user-sessions', icon: null, current: false, group: 'general' },
  { name: 'AI Assistant', href: '#ai-assistant', icon: null, current: false, group: 'general' },
  { name: 'Billing', href: '#billing', icon: null, current: false, group: 'general' },
  { name: 'Staff Online', href: '#staff-online', icon: null, current: false, group: 'general' },
  { name: 'Organization Tree', href: '#organization-tree', icon: null, current: false, group: 'general' },
  { name: 'New Feed', href: '#news-feed', icon: null, current: false, group: 'general' },
  { name: 'Task Calendar', href: '#task-calendar', icon: null, current: false, group: 'tasks' },
  { name: 'Daily Task Timeline', href: '#daily-task-timeline', icon: null, current: false, group: 'tasks' },
  { name: 'Team Task Calendar', href: '#team-task-calendar', icon: null, current: false, group: 'tasks' },
  { name: 'Bottlenecks', href: '#bottlenecks', icon: null, current: false, group: 'tasks' },
  { name: 'Bottleneck Analysis', href: '#bottleneck-analysis', icon: null, current: false, group: 'tasks' },
  { name: 'Create Project', href: '#create-project', icon: null, current: false, group: 'projects' },
  { name: 'Kanban Board', href: '#kanban-board', icon: null, current: false, group: 'projects' },
  { name: 'Daily Tasks', href: '#project-daily-tasks', icon: null, current: false, group: 'projects' },
  { name: 'Project Meetings', href: '#project-meetings', icon: null, current: false, group: 'projects' },
  { name: 'Project Chat', href: '#project-chat', icon: null, current: false, group: 'projects' },
  { name: 'CV Scanner', href: '#cv-scanner', icon: null, current: false, group: 'recruitment' },
  { name: 'Interview Meetings', href: '#interview-meetings', icon: null, current: false, group: 'recruitment' },
  { name: 'Document Builder', href: '#document-builder', icon: null, current: false, group: 'training' },
  { name: 'Quiz Builder', href: '#quiz-builder', icon: null, current: false, group: 'training' },
  { name: 'Training Stats', href: '#training-stats', icon: null, current: false, group: 'training' },
  { name: 'Knowledge Tree', href: '#knowledge-tree', icon: null, current: false, group: 'training' },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export default function Meetings() {
  const Navigate = useNavigate();
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [meetings, setMeetings] = useState([]);
  const [loading, setLoading] = useState(false);
  const [staff, setStaff] = useState([]);
  const [bookingState, setBookingState] = useState({});

  const user = useContext(AuthContext);

  // Use currentMonth for calendar view
  const startDate = startOfWeek(startOfMonth(currentMonth), { weekStartsOn: 1 });
  const endDate = endOfWeek(endOfMonth(currentMonth), { weekStartsOn: 1 });

  const days = [];
  let day = startOfDay(startDate);
  while (day <= endDate) {
    days.push(day);
    day = add(day, { days: 1 });
  }

  useEffect(() => {
    fetchStaff();
    fetchMeetings(selectedDate);
    // eslint-disable-next-line
  }, []);

  const fetchMeetings = async (date) => {
    try {
      setLoading(true);
      const formattedDate = format(date, 'yyyy-MM-dd');
      const response = await fetch(`https://api.insightos.co.uk/sales/meetings/${formattedDate}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();
      setMeetings(Array.isArray(data.data) ? data.data : []);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const fetchStaff = async () => {
    try {
      const response = await fetch('https://api.insightos.co.uk/api/staff', {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();
      setStaff(data.data);
    } catch (error) {
      console.error(error);
    }
  };

  const previousMonth = () => setCurrentMonth(add(currentMonth, { months: -1 }));
  const nextMonth = () => setCurrentMonth(add(currentMonth, { months: 1 }));

  // When currentMonth changes, update selectedDate and fetch meetings for the first day of the new month
  useEffect(() => {
    setSelectedDate(startOfMonth(currentMonth));
    fetchMeetings(startOfMonth(currentMonth));
    // eslint-disable-next-line
  }, [currentMonth]);

  // No AI features for admin calendar view

  const toSeconds = (time = '00:00:00') => {
    const [hour = '0', minute = '0', second = '0'] = time.split(':');
    const safeParse = (value) => {
      const parsed = parseInt(value, 10);
      return Number.isNaN(parsed) ? 0 : parsed;
    };

    return safeParse(hour) * 3600 + safeParse(minute) * 60 + safeParse(second);
  };

  const sortedMeetings = [...meetings].sort((a, b) => toSeconds(a.SlotStart || a.Time) - toSeconds(b.SlotStart || b.Time));

  return (
    <div className="min-h-screen bg-gray-50">
      {loading && <LoadingComponent />}
      <Navbar />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="lg:grid lg:grid-cols-12 lg:gap-8">
          {/* Meetings Section */}
          <div className="lg:col-span-7 xl:col-span-8">
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
              <div className="flex items-center justify-between mb-6">
                <h2 className="text-2xl font-bold text-gray-900">Open Appointments</h2>
                <div className="flex items-center space-x-4">
                  {user && user.googleCalendarPermission ? (
                    <div className="inline-flex items-center px-3 py-2 rounded-md bg-green-50 text-green-700 text-sm font-medium">
                      <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                      </svg>
                      Google Calendar Synced
                    </div>
                  ) : (
                    <button
                      onClick={connectGoogleCalendar}
                      className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    >
                      <img className="w-5 h-5 mr-2" src="https://www.svgrepo.com/show/475656/google-color.svg" alt="Google" />
                      Sync Google Calendar
                    </button>
                  )}
                </div>
              </div>

              {/* Meetings List */}
              <div className="space-y-4">
                {meetings.length > 0 ? (
                  sortedMeetings.map((meeting, idx) => {
                    // Background based on MeetingType
                    let meetingBackgroundColor = 'bg-gray-50 border-gray-200';
                    let typeColor = 'text-gray-500';
                    if (meeting.MeetingType === 'Training') {
                      meetingBackgroundColor = 'bg-blue-50 border-blue-200';
                      typeColor = 'text-blue-600';
                    } else if (meeting.MeetingType === 'Sales') {
                      meetingBackgroundColor = 'bg-yellow-50 border-yellow-200';
                      typeColor = 'text-yellow-600';
                    } else if (meeting.MeetingType === 'Onboarding') {
                      meetingBackgroundColor = 'bg-emerald-50 border-emerald-200';
                      typeColor = 'text-emerald-600';
                    }

                    const startTime = meeting.SlotStart || meeting.Time || meeting.MeetingStart || '';
                    const endTime = meeting.SlotEnd || meeting.FinishTime || meeting.MeetingEnd || '';

                    return (
                      <div key={idx} className={`rounded-lg border ${meetingBackgroundColor} p-6 shadow-sm hover:shadow-md transition-shadow duration-200`}>
                        <div className="flex items-start justify-between">
                          <div className="flex-1">
                            <div className="flex items-center space-x-3 mb-2">
                              <ClockIcon className="h-5 w-5 text-indigo-600" />
                              <span className="text-lg font-semibold text-gray-900">
                                {startTime} {endTime ? `- ${endTime}` : ''}
                              </span>
                            </div>
                            <h3 className="text-xl font-bold text-indigo-700 mb-2">{meeting.CompanyName || meeting.Name}</h3>
                            <div className="flex items-center space-x-4 text-sm text-gray-600">
                              {meeting.MeetingType && (
                                <div className="flex items-center space-x-1">
                                  <MapPinIcon className="h-4 w-4" />
                                  <span>Google Meet</span>
                                </div>
                              )}
                              <div className="flex items-center space-x-1">
                                <UserCircleIcon className="h-4 w-4" />
                                <span>{meeting.Attendees || 'No attendees'}</span>
                                {meeting.CreatedBy && <span className="text-gray-500">({meeting.CreatedBy})</span>}
                              </div>
                            </div>
                            <div className="mt-2">
                              <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${typeColor} bg-current bg-opacity-10`}>
                                {meeting.MeetingType || 'Open Slot'}
                              </span>
                            </div>
                          </div>
                          <div className="ml-6 flex-shrink-0">
                            {meeting.MeetingType ? (
                              <button
                                onClick={() => {
                                  try {
                                    if (meeting.GoogleMeetUrl) window.open(meeting.GoogleMeetUrl, '_blank');
                                  } catch (err) {
                                    console.error('Failed to open Google Meet URL', err);
                                  }
                                  Navigate('/meeting', { state: { meeting } });
                                }}
                                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                              >
                                <img src="https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_1x_web_512dp.png" alt="Meet" className="h-5 w-5 mr-2 bg-white rounded-full p-0.5" />
                                Join Meeting
                              </button>
                            ) : (
                              <div className="space-y-3">
                                <div>
                                  <label className="block text-sm font-medium text-gray-700 mb-1">Session Type</label>
                                  <div className="block w-full px-3 py-2 text-sm font-semibold text-amber-700 bg-amber-50 border border-amber-200 rounded-md">
                                    Sales
                                  </div>
                                </div>
                                <div>
                                  <label className="block text-sm font-medium text-gray-700 mb-1">Select Attendees</label>
                                  <select
                                    multiple
                                    value={bookingState[meeting.id]?.attendees || []}
                                    onChange={(e) => {
                                      const selected = Array.from(e.target.selectedOptions, option => option.value);
                                      setBookingState(prev => ({...prev, [meeting.id]: {...(prev[meeting.id] || {type: 'Sales'}), attendees: selected}}));
                                    }}
                                    className="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md h-24"
                                  >
                                    {staff.map(s => (
                                      <option key={s.Email} value={s.Email}>{s.Name}</option>
                                    ))}
                                  </select>
                                </div>
                                <button
                                  onClick={async () => {
                                    const current = bookingState[meeting.id] || {type: 'Sales', attendees: []};
                                    if (current.attendees.length === 0) return;
                                    setLoading(true);
                                    try {
                                      await fetch('https://api.insightos.co.uk/api/booktrainingsession', {
                                        method: 'POST',
                                        headers: { 'Content-Type': 'application/json' },
                                        credentials: 'include',
                                        body: JSON.stringify({ meetingId: meeting.id, type: 'Sales', attendees: current.attendees, notes: 'Sales' }),
                                      });
                                      fetchMeetings(selectedDate);
                                    } catch (err) {
                                      console.error('Failed to book session', err);
                                    } finally {
                                      setLoading(false);
                                    }
                                  }}
                                  className="w-full inline-flex justify-center items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                >
                                  Book Session
                                </button>
                              </div>
                            )}
                          </div>
                        </div>

                        {meeting.Notes && (
                          <div className="mt-4 pt-4 border-t border-gray-200">
                            <span className="block text-sm font-medium text-gray-700">Notes:</span>
                            <p className="text-sm text-gray-600 mt-1">{meeting.Notes}</p>
                          </div>
                        )}
                      </div>
                    );
                  })
                ) : (
                  <div className="text-center py-12">
                    <ClockIcon className="mx-auto h-12 w-12 text-gray-400" />
                    <h3 className="mt-2 text-sm font-medium text-gray-900">No appointments</h3>
                    <p className="mt-1 text-sm text-gray-500">No meetings scheduled for this day.</p>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Calendar Section */}
          <div className="mt-8 lg:mt-0 lg:col-start-8 lg:col-end-13 xl:col-start-9">
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
              <div className="flex items-center justify-between mb-6">
                <button
                  type="button"
                  onClick={previousMonth}
                  className="p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
                >
                  <span className="sr-only">Previous month</span>
                  <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" />
                </button>
                <h3 className="text-lg font-semibold text-gray-900">{format(currentMonth, 'MMMM yyyy')}</h3>
                <button
                  type="button"
                  onClick={nextMonth}
                  className="p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
                >
                  <span className="sr-only">Next month</span>
                  <ChevronRightIcon className="h-5 w-5" aria-hidden="true" />
                </button>
              </div>

              <div className="grid grid-cols-7 gap-1 mb-4">
                {['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].map((day) => (
                  <div key={day} className="p-2 text-center text-sm font-medium text-gray-500">
                    {day}
                  </div>
                ))}
              </div>

              <div className="grid grid-cols-7 gap-1">
                {days.map((day, dayIdx) => (
                  <button
                    key={day.toISOString()}
                    onClick={() => {
                      setSelectedDate(day);
                      fetchMeetings(day);
                    }}
                    type="button"
                    className={classNames(
                      'h-10 w-10 rounded-md text-center text-sm font-medium focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500',
                      isSameMonth(day, currentMonth) ? 'text-gray-900 hover:bg-gray-100' : 'text-gray-400',
                      isToday(day) && 'bg-indigo-600 text-white',
                      selectedDate && day.toDateString() === selectedDate.toDateString() && !isToday(day) && 'bg-indigo-100 text-indigo-900',
                      selectedDate && day.toDateString() === selectedDate.toDateString() && isToday(day) && 'ring-2 ring-indigo-600'
                    )}
                  >
                    {format(day, 'd')}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
